import { tenantSettings } from '$lib/domain/tenantSettings/tenantSettings'
import { SettingsV1TenantType } from '@sdk/Api'
import { type Readable, derived } from 'svelte/store'

export const tenantType: Readable<SettingsV1TenantType> = derived(
	[tenantSettings],
	([$tenantSettings]) => {
		return $tenantSettings.tenantType
	},
)
